import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SettingsService } from '@services/settings.service';
import { CcssService } from '@services/ccss/ccss.service';
import { SubscriptionManager } from '@zelis/platform-ui-components';
import { TrackByUtilities } from '@utilities/trackByFn.utilities';

@Component({
  selector: 'app-external-links',
  templateUrl: './external-links.component.html',
  styleUrls: ['./external-links.component.scss'],
})
export class ExternalLinksComponent implements OnDestroy {
  public hasFootnote: boolean = false;
  public showCustomerServiceLayout: boolean = false;
  public links: any[] = [];
  public show: boolean = false;
  public flexWidth: number = 25;
  public trackByName: any = TrackByUtilities.getTrackByFn('name');
  private subscriptions = new SubscriptionManager();

  constructor(
    private settingsService: SettingsService,
    public ccss: CcssService
  ) {
    this.subscriptions.add(this.fetchLinks());
    this.subscriptions.add(this.subscribeToFooterBool());
    this.subscriptions.add(this.subscribeToCustServInfoLayout());
  }

  ngOnDestroy() {
    this.subscriptions.destroy();
  }

  public fetchLinks(): Subscription {
    return this.settingsService
      .getSetting('external_link_tiles')
      .subscribe((links) => {
        this.links = links?.tiles;
        if (this.links && this.links.length > 0) {
          this.show = true;
          this.flexWidth = Math.round((1 / this.links.length) * 100);
        }
      });
  }

  private subscribeToCustServInfoLayout(): Subscription {
    return this.settingsService
      .getSetting('customer_service_info_layer')
      .subscribe((val) => (this.showCustomerServiceLayout = val));
  }

  private subscribeToFooterBool(): Subscription {
    return this.settingsService
      .getSetting('has_home_footnote')
      .subscribe((val) => (this.hasFootnote = val));
  }
}
